(function () {
  const HOVER_DELAY = 140;
  const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');

  function activate(menu, tab) {
    const tabs = Array.from(menu.querySelectorAll('[data-sa-brand-dept]'));
    const panels = Array.from(menu.querySelectorAll('[data-sa-brand-panel]'));
    const index = tabs.indexOf(tab);

    if (index < 0) return;

    tabs.forEach((item, itemIndex) => {
      const active = itemIndex === index;
      item.classList.toggle('is-active', active);
      item.setAttribute('aria-selected', active ? 'true' : 'false');
      item.setAttribute('tabindex', active ? '0' : '-1');
    });

    panels.forEach((panel, panelIndex) => {
      const active = panelIndex === index;
      panel.classList.toggle('is-active', active);
      panel.hidden = !active;
    });
  }

  function focusTab(menu, index) {
    const tabs = Array.from(menu.querySelectorAll('[data-sa-brand-dept]'));
    const next = tabs[index];

    if (!next) return;
    activate(menu, next);
    next.focus();
  }

  function initMenu(menu) {
    if (menu.dataset.saBrandMegaReady === 'true') return;
    menu.dataset.saBrandMegaReady = 'true';

    const tabs = Array.from(menu.querySelectorAll('[data-sa-brand-dept]'));
    const container = menu.closest('.submenu-container');
    const trigger = container ? container.querySelector(':scope > a') : null;
    let hoverTimer = null;

    if (trigger) {
      trigger.setAttribute('aria-haspopup', 'true');
      trigger.setAttribute('aria-expanded', 'false');
      trigger.addEventListener('keydown', (event) => {
        if (!['ArrowDown', 'Enter', ' '].includes(event.key)) return;
        event.preventDefault();
        container && container.classList.remove('sa-brand-mega--keyboard-closed');
        focusTab(menu, 0);
      });
    }

    if (container && trigger) {
      container.addEventListener('pointerenter', () => {
        container.classList.remove('sa-brand-mega--keyboard-closed');
        trigger.setAttribute('aria-expanded', 'true');
      });
      container.addEventListener('pointerleave', () => {
        trigger.setAttribute('aria-expanded', 'false');
      });
      container.addEventListener('focusin', () => {
        if (container.classList.contains('sa-brand-mega--keyboard-closed')) return;
        trigger.setAttribute('aria-expanded', 'true');
      });
      container.addEventListener('focusout', () => {
        window.setTimeout(() => {
          if (container.contains(document.activeElement)) return;
          container.classList.remove('sa-brand-mega--keyboard-closed');
          trigger.setAttribute('aria-expanded', 'false');
        }, 0);
      });
    }

    tabs.forEach((tab, index) => {
      tab.addEventListener('pointerenter', () => {
        if (!finePointer.matches) return;
        window.clearTimeout(hoverTimer);
        hoverTimer = window.setTimeout(() => activate(menu, tab), HOVER_DELAY);
      });

      tab.addEventListener('pointerleave', () => {
        window.clearTimeout(hoverTimer);
      });

      tab.addEventListener('focus', () => activate(menu, tab));

      tab.addEventListener('click', (event) => {
        event.preventDefault();
        activate(menu, tab);
      });

      tab.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          event.preventDefault();
          if (container) container.classList.add('sa-brand-mega--keyboard-closed');
          if (trigger) trigger.setAttribute('aria-expanded', 'false');
          trigger && trigger.focus();
          return;
        }

        if (event.key === 'Home') {
          event.preventDefault();
          focusTab(menu, 0);
          return;
        }

        if (event.key === 'End') {
          event.preventDefault();
          focusTab(menu, tabs.length - 1);
          return;
        }

        if (event.key === 'ArrowDown' || event.key === 'ArrowRight') {
          event.preventDefault();
          focusTab(menu, (index + 1) % tabs.length);
          return;
        }

        if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') {
          event.preventDefault();
          focusTab(menu, (index - 1 + tabs.length) % tabs.length);
        }
      });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-sa-brand-mega]').forEach(initMenu);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
